import { useEffect } from 'react';

import { LayoutModal } from '@layouts';
import { useAppDispatch } from '@store/';
import { hideModal } from '@store/Modal';
import { createUsersRequest } from '@store/Users';
import { UIButton, UIError, UIInput, UIRadio, UISelect } from '@ui';
import { Button } from '@utils/utility-property';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { INITIAL_VALUES } from '../../../modules/Users/FormUsers/constant';
import { validationSchema } from '../../../modules/Users/FormUsers/schema';

const WidgetsModalMobileUsers = () => {
  // const [isOpenColor, setIsOpenColor] = useState(false);
  const { loading } = useSelector((state) => state.users);

  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();

  const handlerSubmit = (values) =>
    dispatch(createUsersRequest({ ...values, role: values?.role?.id || null }));

  const form = useFormik({
    enableReinitialize: true,
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema(),
    onSubmit: handlerSubmit,
  });

  useEffect(() => {
    validationSchema();
  }, [i18n.language]);

  return (
    <LayoutModal title={t('USERS.ADD_USER')} className="modal__users">
      <form onSubmit={form.handleSubmit} className="modal__added__items">
        {/* <UIColor
          className="users-color h6 fw700"
          setColor={(color) => form.setFieldValue('color', color)}
          color={form.values.color}
          setIsOpenColor={setIsOpenColor}
          isOpenColor={isOpenColor}
        /> */}
        <div className="modal-users__items">
          <UIInput
            label={t('COMMON.EMAIL')}
            name="email"
            placeholder={t('COMMON.EMAIL')}
            className="input input__icon"
            classLabel="fw600 icon_necessarily"
            value={form.values.email}
            onChange={form.handleChange}
            isValid={!(form.errors.email && form.touched.email)}
            validateText={form.errors.email}
          />
          <UIInput
            label={t('COMMON.NAME')}
            name="first_name"
            placeholder={t('COMMON.NAME')}
            classLabel="fw600 icon_necessarily"
            className="input input__icon"
            value={form.values.first_name}
            onChange={form.handleChange}
            isValid={!(form.errors.first_name && form.touched.first_name)}
            validateText={form.errors.first_name}
          />
          <UIInput
            label={t('COMMON.SURNAME')}
            name="last_name"
            placeholder={t('COMMON.SURNAME')}
            classLabel="fw600"
            className="input input__icon"
            value={form.values.last_name}
            onChange={form.handleChange}
            isValid={!(form.errors.last_name && form.touched.last_name)}
            validateText={form.errors.last_name}
          />
          <UIInput
            label={t('COMMON.PHONE')}
            name="phone"
            placeholder={t('COMMON.PHONE')}
            classLabel="fw600"
            className="input input__icon"
            value={form.values.phone}
            onChange={form.handleChange}
            isValid={!(form.errors.phone && form.touched.phone)}
            validateText={form.errors.phone}
          />
          <div className="select-column">
            <UISelect
              id="role"
              label={t('COMMON.ROLE')}
              classLabel="h6 fw600"
              isSearchable={false}
              options={[{ id: 'admin', name: t('COMMON.ADMINISTRATOR') }]}
              name="role"
              onChange={(value) => {
                form.setFieldValue('role', value);
              }}
              value={form.values.role}
              placeholder={t('COMMON.ROLE')}
              isValid={!(form.errors.role && form.touched.role)}
              validateText={form.errors.role}
            />
          </div>
          <UIInput
            label={t('COMMON.PASSWORD')}
            name="password"
            type="password"
            className="input input__icon"
            placeholder={t('COMMON.ENTER_PASSWORD')}
            classLabel="fw600 icon_necessarily"
            value={form.values.password}
            onChange={form.handleChange}
            isValid={!(form.errors.password && form.touched.password)}
            validateText={form.errors.password}
            isShowPassword
          />
          <div className="modal-status__wrap">
            <div className="radio-wrap users-radio">
              <span className="h6 fw700">{t('COMMON.STATUS')}</span>
              <div>
                <UIRadio
                  id="active_3"
                  type="radio"
                  name="active"
                  checked={form.values.active === '1'}
                  className="custom-radio"
                  value="1"
                  onChange={form.handleChange}
                >
                  {t('COMMON.ACTIVE')}
                </UIRadio>
                <UIRadio
                  id="inactive_3"
                  type="radio"
                  name="active"
                  className="custom-radio"
                  value="0"
                  checked={form.values.active === '0'}
                  onChange={form.handleChange}
                >
                  {t('COMMON.INACTIVE')}
                </UIRadio>
              </div>
              <UIError
                isValid={!(form.errors.active && form.touched.active)}
                text={form.errors.active}
              />
            </div>
          </div>
          <div className="added-btn">
            <UIButton
              loading={loading}
              className="btn outline__blue"
              type={Button.SUBMIT}
            >
              <span>{t('COMMON.SAVE')}</span>
            </UIButton>
            <UIButton
              handler={() => dispatch(hideModal())}
              className="btn btn__gray"
            >
              {t('COMMON.CANCEL')}
            </UIButton>
          </div>
        </div>
      </form>
    </LayoutModal>
  );
};

export default WidgetsModalMobileUsers;
